export default defineNuxtPlugin(() => {
  const { isIntegrationEnabled } = useUtils()
  if (!isIntegrationEnabled('constructor')) return
  const scriptOnDemand = runScriptOnDemand()

  runOnNuxtReady(() => {
    scriptOnDemand.addSrc('https://cnstrc.com/js/cust/realtruck_amZrnR.js')
    scriptOnDemand.load()
  })
})
